import { AnnualReportAction } from '../interfaces/audit-log.interface';

export interface IAuditLogDTO {
    action: AnnualReportAction;
    createdAt: Date;

    userName: string;
}
